import { useCallback, useEffect, useMemo, useState } from "react"

import { debounce } from "lodash"

import { useBuilderStore } from "../store"

const SAVE_TIMEOUT = 5000
const STORAGE_KEY = 'cms:post'

export default function useAutoSave() {
  const { autoSave, disableAutoSave } = useBuilderStore()

  const [saved, setSaved] = useState(true)

  const cleanLocalStorage = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY)
  }, [])

  const setLocalStorage = useCallback(data => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data))
  }, [])

  const getLocalStorage = useCallback(() => {
    const data = localStorage.getItem(STORAGE_KEY)
    if (!data) {
      return null
    }
    return JSON.parse(data)
  }, [])

  const saveDebounced = useMemo(() => debounce(async data => {
    try {
      if (disableAutoSave) return

      await autoSave(data)
      setSaved(true)
      cleanLocalStorage()
    } catch (error) {
      return;
    }
  }, SAVE_TIMEOUT), [autoSave, cleanLocalStorage, disableAutoSave])

  const handleAutoSave = useCallback(async data => {
    setLocalStorage(data)
    setSaved(false)
    saveDebounced(data)
  }, [saveDebounced, setLocalStorage])

  useEffect(() => () => saveDebounced.cancel(), [saveDebounced])

  return useMemo(() => ({
    handleAutoSave,
    saved,
    restoreUnsaved: () => getLocalStorage(),
  }), [handleAutoSave, getLocalStorage, saved])
}

